//
//
//
//
//
//
//
//
//
//
//

import mixinVerify from '@/utils/mixin/mixinVerify'
import  Scheme  from './scheme'
import  Model  from './model'
import { deepClone } from '@/utils/commonUtils'
import Giveup from './Giveup'
import { toApp } from '@/utils/appBridge'
import SchemeIcon from './schemeIcon'
export default {
  mixins:[mixinVerify],
  data(){
    return{
      fromPageData:{},
      modules:[], // 
      schemeShow:false, //是否展示升级保障
      schemeCurrent:{
        schemeCode:''
      }, //选中的方案
      interceptLayerShow:false, //放弃保障弹窗显示隐藏

    }
  },

  components:{
    Scheme,
    Giveup,
    Model,
    SchemeIcon
  },
  props:{
    allData:{
      type:[Array,Object],
      default(){
        return {
          followOrderPrice:{
            commodityPrice:''
          }
        }
      }
    },
  },
  created () {
  },
  mounted () {
    const _this = this
    if(this.CHANNAL_ID == 'APP'){
      // 用户返回时调用的js方法
      window['SyBridge_For_Web']['interceptSuccess'] = () => {
          _this.interceptLayerShow = true
      }
      // 监听 返回操作
      toApp("setInterceptUrl",{
        Intercept:true
      });
    }
  },
  beforeDestroy(){
    if(this.CHANNAL_ID == 'APP'){
      // 取消监听
      toApp("setInterceptUrl",{
        Intercept:false
      });
    }
  },
  methods:{
    changeData({allFromData,fromPageData}){
      this.fromPageData = fromPageData;
    },
    schemeLayerShow(item){
      this.schemeShow = true 
      this.STATISTICS_CONFIG.insur_insurinfoinput_scheme_change_click({"ex":{scheme:item.showName }})
    },
    // 方案修改
    changeScheme(data){
      this.schemeCurrent = data
      this.add(data)
      console.log('得到的方案值', data)
    },
    // 更新方案保障
    add(newValue){
      const _this = this;
      if(!newValue){
        return false
      }
      if(!this.schemeCurrent.schemeCode){
        this.modules =  this.allData.modules;
        return false
      }
      let defaultValueHTML = `<img style="width:0.75rem;margin: -0.1rem 0.05rem 0rem -0.8rem;" src="${newValue.schemeIcon}"><span class="ft15">￥${newValue.commodityPrice}</span><span class="ft12">/单 </span>`
      // 选中方案为活动方案 增加划线价
      if(newValue.selectedLabel == '免费领'){
        defaultValueHTML += `<span class="ft12 text-lineThrough ab3">￥${newValue.originalPrice}/单</span>`
      }
      
      const zdyArr = [
              {
                  componentTypeCode: "WBK001",
                  elementCode: newValue.schemeCode,
                  elementEnums: "ZDY001",
                  elementName: newValue.schemeName,
                  pageDetail: '{"defaultHint":"保费","writeLimit":20,"inputLimit":[]}',
                  showName: newValue.schemeName,
                  readonly:true,
                  defaultValue:defaultValueHTML,
                  rightChildren:{
                      component:SchemeIcon,  //文本框右侧传入button组件 
                      props:{
                        schemes:this.allData.schemes
                      },
                      event:{
                        schemeLayerShow:(item)=>{_this.schemeLayerShow(item)}
                      }
                  },
                  selectedLabel:newValue.selectedLabel
              }
          ]
          // 合并到 modules里 在页面中遍历展示
          let newModules = deepClone( this.allData.modules )
          newModules[0].elements = zdyArr.concat(this.allData.modules[0].elements)
          this.modules =  newModules;
    },
    btnClick(){
      this.$emit('btnClick')
    }
  },
}


